import { useEffect, useState } from 'react';
import { api } from '../../core/apiClient.ts';

export interface OAuthStatus { status: 'pending' | 'processing' | 'success' | 'error' | 'expired'; message?: string | null }
export function useOAuthStatus(sessionId: string | undefined, expiresAt: string | undefined) {
  const [result, setResult] = useState<OAuthStatus | null>(null);
  useEffect(() => {
    setResult(null);
    if (!sessionId) return;
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout>;
    const poll = async () => {
      try {
        const next = await api.get<OAuthStatus>(`/api/auth/sessions/${encodeURIComponent(sessionId)}`);
        if (cancelled) return;
        setResult(next);
        if (['success', 'error', 'expired'].includes(next.status)) return;
      } catch {
        if (expiresAt && Date.now() >= Date.parse(expiresAt)) {
          if (!cancelled) setResult({ status: 'expired', message: 'Час очікування минув. Створіть нове посилання.' });
          return;
        }
        if (!cancelled) setResult({ status: 'pending', message: 'Не вдалося перевірити стан. Повторюємо перевірку…' });
      }
      if (!cancelled) timer = setTimeout(poll, 2000);
    };
    void poll();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [sessionId, expiresAt]);
  return result;
}
